const asl = {
    state: {
      skipQuery:{},
    },
    mutations: {
        saveQueryData: (state, item) => {
          state.skipQuery=item
        },
    },
    actions: {
      saveQueryData({ commit }, item){
          commit('saveQueryData', item)
        },
    }
  }
  
  export default asl
  